/* global jQuery COMPONENTS */

COMPONENTS.ComponentTerritoryMap = (function ($) {
  function ComponentTerritoryMap () {
    this.$component = $('[data-ecs-component="component-territorymap"]')
    this.$accordion = this.$component.find('[data-ecs-components-control="territory-map-accordion"]')
    this.$accordionCategories = this.$component.find('[data-ecs-accordion-category]')
    this.$accordionToggles = this.$component.find('[data-ecs-accordion-control]')
    this.$territoryMap = this.$component.find('[data-ecs-components-control="territory-map"]')
    this.$territories = this.$territoryMap.find('[data-ecs-territory-id]')
    this.$activeTerritories = this.$territories.filter('.ecs_listed')
  }

  ComponentTerritoryMap.prototype.init = function () {
    const component = this

    if (component.$accordion.length >= 1) {
      // no accordion on page
      component.$accordion.accordion()
    }

    $(component.$accordionToggles).each(function () {
      $(this).click(function () {
        const $territoryNeedle = $(this).attr('data-ecs-accordion-control')

        component.$accordionCategories.each(function () {
          $(this).removeClass('ecs_active')
        })
        component.$accordionCategories.filter('[data-ecs-accordion-category="' + $territoryNeedle + '"]').addClass('ecs_active')

        component.$territories.each(function () {
          $(this).removeClass('ecs_active')
        })
        $(component.$territories).filter('[data-ecs-territory-id="' + $territoryNeedle + '"]').addClass('ecs_active')
      })
    })

    $(component.$activeTerritories).each(function () {
      $(this).click(function () {
        const $accordionNeedle = $(this).attr('data-ecs-territory-id')

        $(component.$accordionToggles).filter('[data-ecs-accordion-control="' + $accordionNeedle + '"]').first().click()
      })
    })
  }

  return ComponentTerritoryMap
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.ComponentTerritoryMap = new COMPONENTS.ComponentTerritoryMap()
  COMPONENTS.ComponentTerritoryMap.init()
})
